import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useToggleFavorite } from '../hooks/useCandidates';

interface FavoriteButtonProps {
  candidateId: number;
  isFavorite: boolean;
  className?: string;
}

/**
 * Bouton étoile pour marquer un candidat comme favori (partagé au niveau société).
 * Conçu pour être posé dans une carte cliquable : stoppe la propagation pour ne pas
 * déclencher la navigation du lien parent.
 */
export function FavoriteButton({ candidateId, isFavorite, className }: FavoriteButtonProps) {
  const toggleFavorite = useToggleFavorite();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (toggleFavorite.isPending) return;
    toggleFavorite.mutate({ id: candidateId, isFavorite: !isFavorite });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={toggleFavorite.isPending}
      aria-label={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
      title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
      className={cn(
        'rounded-full p-1.5 transition-colors hover:bg-muted disabled:opacity-50',
        isFavorite ? 'text-yellow-400' : 'text-muted-foreground/50 hover:text-yellow-400',
        className,
      )}
    >
      <Star className={cn('h-4 w-4', isFavorite && 'fill-current')} />
    </button>
  );
}
